import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Schedule } from 'src/app/api/services/schedule';
import { ItemSelectorDialogComponent } from 'src/app/components/folders/item-selector-dialog/item-selector-dialog.component';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';

@Component({
    selector: 'preview-selector',
    templateUrl: './preview-selector.component.html',
    styleUrls: ['./preview-selector.component.scss'],
    standalone: false
})
export class PreviewSelectorComponent {

  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;
  @Input() selectedItem: any;
  @Input() label: string;
  @Input() additionalClass: string;
  @Input() additionalTooltipClass: string;
  @Input() placement: string;
  @Output() selectedItemChange = new EventEmitter<{}>();
  filterConfig = {
    placeholder: 'Search schedules'
  };
  search = {
    sortBy: 'changeDate',
    reverse: true
  };
  schedules: any;

  private matDialog = inject(MatDialog);

  constructor(
    // init service
    protected scheduleSelectorService: ScheduleSelectorService,
  ) { }

  openDialog () {
    const dialogRef =this.matDialog.open(
      ItemSelectorDialogComponent<Schedule>,
      { 
        data: { kind: 'Schedule', multiple: false }, 
        ariaLabelledBy: 'title',
        ariaModal: true
      }
    );
    dialogRef.componentInstance.itemSelectorService = this.scheduleSelectorService;
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.action) {
        result.action === 'add'
          ? this.scheduleSelectorService.addSchedule()
          : this.scheduleSelectorService.editSchedule(result.item);
      } else if (result) {
        this.select(result);
      }
    });
  }

  select (schedule) {
    this.selectedItem = schedule;
    this.selectedItemChange.emit(schedule);
  }

}
